function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a3b1c3;}.b{fill:#fff;}.c{fill:#d6dbe0;}.d{fill:#0c9ba9;}.e{fill:#f4f4f3;}.f{fill:#2e333b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-959.403 -1768.064)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1042.821,1850.881H1037.8v-2.511h5.021Zm6.291-11.3h-2.51v5.021h2.51ZM978.035,1776.9h-5.02v2.51h5.02Zm-8.15,5.655h-2.51v5.021h2.51Zm76.708.628v5.021h2.51v-5.021Zm-8.786-6.291v2.51h5.02v-2.51Zm-70.425,63.339v5.021h2.51v-5.021Zm5.655,8.15v2.51h5.021v-2.51Z",
  transform: "translate(-1.805 -1.998)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M985.1,1775.988c-7.233,15.419-20.19,22.265-23.673,29.7s-6.531,25.044,27.655,41.076,49.049-2.61,52.885-10.784c17.95-38.273-44.057-87.3-56.867-59.988",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M1020.547,1825.417a14.7,14.7,0,1,1,0-29.4,14.882,14.882,0,0,1,2.645.248,14.688,14.688,0,0,0,0,28.9,14.837,14.837,0,0,1-2.645.249m-7.056,5.88H1008.2a11.761,11.761,0,0,0-11.759,11.76v5.88h5.292v-5.88a11.761,11.761,0,0,1,11.759-11.76m-30.232-7.709a137.8,137.8,0,0,0,2.7,25.349h3.6a139.858,139.858,0,0,1-2.759-23.585Z",
  transform: "translate(-5.402 -6.33)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "d",
  width: 17.415,
  height: 26.122,
  rx: 3.125,
  transform: "translate(973.624 1796.251)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "e",
  width: 2.213,
  height: 2.764,
  transform: "translate(977.39 1813.079)"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M990.919,1824.421h-9.883v-1.763h9.883Zm0-5.529H984.25v1.763h6.669Zm11.409-8.689a16.463,16.463,0,1,1,16.464,16.462A16.483,16.483,0,0,1,1002.328,1810.2Zm3.528,0a12.936,12.936,0,1,0,12.936-12.936A12.951,12.951,0,0,0,1005.856,1810.2Zm38.806,32.338v5.88h-3.528v-5.88a10.006,10.006,0,0,0-9.994-10h-24.7a10.007,10.007,0,0,0-10,10v5.88h-3.728a146.21,146.21,0,0,1-2.463-18.469h-8.073a145.461,145.461,0,0,0,2.529,18.469h-3.6a146.19,146.19,0,0,1-2.47-18.607,4.184,4.184,0,0,1-3.134-4.043v-21.287a4.185,4.185,0,0,1,4.181-4.181h.573a8.474,8.474,0,0,0,4.364-1.176,1.743,1.743,0,0,0,2.708,0,1.743,1.743,0,0,0,2.707,0,1.759,1.759,0,0,1,1.656,1.176h.573a4.186,4.186,0,0,1,4.181,4.181v21.287a4.185,4.185,0,0,1-2.673,3.9c.155,2.355.377,4.635.627,6.75a13.527,13.527,0,0,1,12.041-7.4h24.7A13.539,13.539,0,0,1,1044.662,1842.541Zm-64.974-16.117h12.581a.654.654,0,0,0,.653-.654v-8.88H979.034v8.88A.654.654,0,0,0,979.688,1826.424Zm-.654-21.941v8.879h13.887v-8.879a.654.654,0,0,0-.653-.654h-.574a8.444,8.444,0,0,0-4.363,1.176,1.742,1.742,0,0,0-2.708,0,1.742,1.742,0,0,0-2.707,0,1.758,1.758,0,0,1-1.656-1.176h-.573A.654.654,0,0,0,979.034,1804.483Zm12.123,5.114H980.8v1.764h10.359Zm0-3.766H980.8v1.763h10.359Z",
  transform: "translate(-3.646 -5.814)"
}));

function SvgTakePhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87.903,
    height: 85,
    viewBox: "0 0 87.903 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/takePhoto.de666921.svg";
export { ForwardRef as ReactComponent };